"use client";
import { useState, useEffect } from "react";
import { BookingModal } from "@/components/BookingModal";
import { ServiceDetailsModal } from "@/components/ServiceDetailsModal";
import { Hero } from "@/components/sections/Hero";
import { About } from "@/components/sections/About";
import { Services } from "@/components/sections/Services";
import { WhyChooseUs } from "@/components/sections/WhyChooseUs";
import { SERVICES_DATA } from "@/lib/constants";
import { Transformations } from "@/components/sections/Transformations";
import { Gallery } from "@/components/sections/Gallery";
import { Contact } from "@/components/sections/Contact";
import { Reviews } from "@/components/sections/Reviews";
// ✅ REMOVED — import { Header } from "@/components/Header";
// SiteHeader is already rendered once, globally, by app/layout.tsx.
// This page used to ALSO render <Header /> directly below, which caused
// two overlapping nav bars stacked on top of each other on the homepage only.
export default function Home() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [selectedService, setSelectedService] = useState<(typeof SERVICES_DATA)[0] | null>(null);
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    const checkAdmin = async () => {
      try {
        const response = await fetch("/api/auth/me?silent=true");
        if (response.ok) {
          const data = await response.json();
          if (data.user?.role === "admin" || data.user?.role === "super-admin") {
            setIsAdmin(true);
          }
        }
      } catch (error) {
        console.error("Error checking admin status:", error);
      }
    };
    checkAdmin();
  }, []);
  // Handles hash scrolling after page fully loads (fixes cross-page nav)
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;
    const timer = setTimeout(() => {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  return (
    <main className="min-h-screen">
      {/* ✅ REMOVED — <Header onBookingClick={() => setIsBookingOpen(true)} /> */}
      <Hero isAdmin={isAdmin} onBookingClick={() => setIsBookingOpen(true)} />
      <About onBookingClick={() => setIsBookingOpen(true)} />
      <Services
        onBookingClick={() => setIsBookingOpen(true)}
        onLearnMore={(service) => setSelectedService(service)}
      />
      <WhyChooseUs />
      <Transformations />
      {/* Patient Reviews — scrolling carousel */}
      <Reviews />
      <Gallery />
      <Contact />
      <BookingModal
        open={isBookingOpen}
        onOpenChange={setIsBookingOpen}
        defaultService={selectedService?.title}
      />
      <ServiceDetailsModal
        open={!!selectedService}
        onOpenChange={(open) => !open && setSelectedService(null)}
        service={selectedService}
        onBookingClick={() => setIsBookingOpen(true)}
      />
    </main>
  );
}
